<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">REGRAS DE ACESSO</span>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>REGRAS ASSOCIADAS</b-alert>
                        <app-tabela
                            idTabela="tblRegrasAcesso"
                            :itens="perfilAcesso.regrasAcesso"
                            :campos="camposRegrasAcesso"
                            :itensPorPagina="0"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="danger"
                                        v-if="
                                            $temAcessoView('CTRLACS-PA-05-02')
                                        "
                                        @click="
                                            confirmaDesassociarSelecionadas()
                                        "
                                        :disabled="
                                            regrasAcessoAssociadasSelecionadas.length ===
                                                0
                                        "
                                        >Desassociar selecionadas</b-button
                                    >
                                </b-button-group>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <span
                                    class="text-danger"
                                    v-if="$temAcessoView('CTRLACS-PA-05-02')"
                                    ><i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Desassociar Regra de Acesso"
                                        @click.stop="
                                            confirmaDesassociarRegraAcesso(
                                                data.regraAcessoId
                                            )
                                        "
                                    ></i
                                ></span>
                                <span
                                    class="text-success"
                                    v-if="
                                        data.status === 1 &&
                                            $temAcessoView('CTRLACS-PA-05-03')
                                    "
                                    ><i
                                        class="fa fa-toggle-on fa-lg icon-button"
                                        title="Desativar Regra de Acesso"
                                        @click.stop="
                                            confirmaDesativarRegraAcesso(
                                                data.regraAcessoId
                                            )
                                        "
                                    ></i
                                ></span>
                                <span
                                    class="text-secondary"
                                    v-if="
                                        data.status === 0 &&
                                            $temAcessoView('CTRLACS-PA-05-03')
                                    "
                                    ><i
                                        class="fa fa-toggle-off fa-lg icon-button"
                                        title="Ativar Regra de Acesso"
                                        @click.stop="
                                            confirmaAtivarRegraAcesso(
                                                data.regraAcessoId
                                            )
                                        "
                                    ></i
                                ></span>
                            </template>
                            <template
                                slot="regraAcessoAssociadaSelecao"
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-PA-05-02')"
                            >
                                <b-form-checkbox
                                    :value="data.regraAcessoId"
                                    v-model="regrasAcessoAssociadasSelecionadas"
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>REGRAS DISPONÍVEIS</b-alert>
                        <app-tabela
                            idTabela="tblRegrasAcessoDisponiveis"
                            :itens="regrasAcesso"
                            :campos="camposRegrasAcessoDisponiveis"
                            :itensPorPagina="0"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        v-if="
                                            $temAcessoView('CTRLACS-PA-05-01')
                                        "
                                        @click="confirmaAssociarSelecionadas()"
                                        :disabled="
                                            regrasAcessoDisponiveisSelecionadas.length ===
                                                0
                                        "
                                        >Associar selecionadas</b-button
                                    >
                                </b-button-group>
                            </template>
                            <template
                                slot="regraAcessoDisponivelSelecao"
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-PA-05-01')"
                            >
                                <b-form-checkbox
                                    :value="data.regraAcessoId"
                                    v-model="
                                        regrasAcessoDisponiveisSelecionadas
                                    "
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PerfisAcessoServicos from './PerfisAcessoServicos'
import RegrasAcessoServicos from './../regrasacesso/RegrasAcessoServicos'

export default {
    data() {
        return {
            regrasAcessoAssociadasSelecionadas: [],
            regrasAcessoDisponiveisSelecionadas: [],
            regrasAcesso: [],
            perfilAcesso: {
                codPerfilAcesso: null,
                descricaoPerfilAcesso: null,
                regrasAcesso: []
            },
            usuarioId: '',
            perfilAcessoIdDetalhado: null,
            camposRegrasAcesso: [
                {
                    key: 'regraAcessoAssociadaSelecao',
                    label: ''
                },
                {
                    key: 'codRegraAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoRegraAcesso',
                    label: 'RegraAcesso',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            camposRegrasAcessoDisponiveis: [
                {
                    key: 'regraAcessoDisponivelSelecao',
                    label: ''
                },
                {
                    key: 'codRegraAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoRegraAcesso',
                    label: 'RegraAcesso',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    methods: {
        obterPerfilRegrasAcesso() {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.obterPorId(
                this.$route.params.perfilAcessoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.perfilAcesso = response.data
                        this.obterRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterRegrasAcesso() {
            this.$store.dispatch('addRequest')
            RegrasAcessoServicos.obterTodas().then(response => {
                if (response) {
                    if (response.success) {
                        this.regrasAcesso = response.data
                        this.atualizarRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarRegrasAcesso() {
            if (this.perfilAcesso.regrasAcesso.length > 0) {
                if (this.regrasAcesso.length > 0) {
                    this.regrasAcesso = this.regrasAcesso.filter(regra => {
                        return this.perfilAcesso.regrasAcesso.every(
                            regraPerfil => {
                                return (
                                    regraPerfil.regraAcessoId !==
                                    regra.regraAcessoId
                                )
                            }
                        )
                    })
                }
            }
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Regras de Acesso',
                html: `Confirma a associação das regras de acesso selecionadas ao perfil <b>${this.perfilAcesso.codPerfilAcesso}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarRegrasAcesso()
                }
            })
        },

        associarRegrasAcesso() {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.associarRegrasAcesso({
                perfilAcessoId: this.$route.params.perfilAcessoId,
                regrasAcessoId: this.regrasAcessoDisponiveisSelecionadas
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.regrasAcessoDisponiveisSelecionadas = []
                        this.obterPerfilRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesassociarRegraAcesso(regraAcessoId) {
            let regraAcessoTemp = this.perfilAcesso.regrasAcesso.filter(
                item => {
                    return item.regraAcessoId === regraAcessoId
                }
            )[0]
            this.$swal({
                title: 'Desassociação de Regra de Acesso',
                html: `Confirma a desassociação da regra de acesso <b>${regraAcessoTemp.codRegraAcesso}</b> do perfil <b>${this.perfilAcesso.codPerfilAcesso}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarRegraAcesso(regraAcessoId)
                }
            })
        },

        desassociarRegraAcesso(regraAcessoId) {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.desassociarRegraAcesso({
                perfilAcessoId: this.$route.params.perfilAcessoId,
                regraAcessoId: regraAcessoId
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro excluído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPerfilRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesassociarSelecionadas() {
            this.$swal({
                title: 'Desassociação de Regras de Acesso',
                html: `Confirma a desassociação das regras de acesso selecionadas do perfil <b>${this.perfilAcesso.codPerfilAcesso}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarRegrasAcesso()
                }
            })
        },

        desassociarRegrasAcesso() {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.desassociarRegrasAcesso({
                perfilAcessoId: this.$route.params.perfilAcessoId,
                regrasAcessoId: this.regrasAcessoAssociadasSelecionadas
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registros desassociados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.regrasAcessoAssociadasSelecionadas = []
                        this.obterPerfilRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesativarRegraAcesso(regraAcessoId) {
            let regraAcessoTemp = this.perfilAcesso.regrasAcesso.filter(
                item => {
                    return item.regraAcessoId === regraAcessoId
                }
            )[0]
            this.$swal({
                title: 'Desativação de Regra de Acesso',
                html: `Confirma a desativação da regra de acesso <b>${regraAcessoTemp.codRegraAcesso}</b> do perfil <b>${this.perfilAcesso.codPerfilAcesso}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarPerfilRegraAcesso(regraAcessoId)
                }
            })
        },

        confirmaAtivarRegraAcesso(regraAcessoId) {
            let regraAcessoTemp = this.perfilAcesso.regrasAcesso.filter(
                item => {
                    return item.regraAcessoId === regraAcessoId
                }
            )[0]
            this.$swal({
                title: 'Ativação de Regra de Acesso',
                html: `Confirma a ativação da regra de acesso <b>${regraAcessoTemp.codRegraAcesso}</b> do perfil <b>${this.perfilAcesso.codPerfilAcesso}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarPerfilRegraAcesso(regraAcessoId)
                }
            })
        },

        atualizarPerfilRegraAcesso(regraAcessoId) {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.atualizarPerfilRegraAcesso({
                perfilAcessoId: this.$route.params.perfilAcessoId,
                regraAcessoId: regraAcessoId
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPerfilRegrasAcesso()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterPerfilRegrasAcesso()
    }
}
</script>
